import request from "@/router/axios";

// 获取公司配置列表
export const getDeptList = (current, size, params, search) => {
  return request({
    url: `/api/blade-system/dept/list2`,
    method: "post",
    data: {
      current,
      size,
      ...params,
      ...search,
    },
  });
};

// 设置公司类型
export const updateDeptType = ( data) => {
  return request({
    url: "/api/blade-system/dept/updateDeptType",
    method: "post",
    data,
  });
};

export const updateOne = (row) => {
  return request({
    url: "/api/blade-system/dept/updateOne",
    method: "post",
    data: row,
  });
};


// 查看代理商配置列表
export const agentConfigPage = (current, size, params, search) => {
  return request({
    url: '/api/blade-system/agentConfig/page',
    method: 'post',
    data: {
      current,
      size,
      ...params,
      ...search,
    },
  })
}

// 代理商接管状态修改接口， 直管， 代管
export const agentConfigTokeOver = (id) => {
  return request({
    url: '/api/blade-system/agentConfig/update',
    method: 'get',
    params: {
      id
    }
  })
}

// 更改代理商的代理状态代理商状态接口,正常代理 终止代理
export const agentConfigUpdateStatus = (data) => {
  return request({
    url: '/api/blade-system/agentConfig/updateStatus',
    method: 'post',
    data
  })
}

// 编辑兜底比例列表
export const getAgentConfigRadioList = (id) => {
  return request({
    url: '/api/blade-system/agentConfig/proportionList',
    method: 'get',
    params: { 
      id
    }
  })
}

// 修改代管商的兜底比例
export const editAngentConfigRadio = (data) => {
  return request({
    url: '/api/blade-system/agentConfig/updateRatio',
    method: 'post',
    data
  })
}